'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _FormValidationService = require('./../../../../common/services/FormValidationService');

var _FormValidationService2 = _interopRequireDefault(_FormValidationService);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RetailPriceListEditController = function () {
  function RetailPriceListEditController($stateParams, enums, retailPriceListService, loadingService, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, RetailPriceListEditController);
    this.enums = enums;
    this.retailPriceListService = retailPriceListService;
    this.loadingService = loadingService;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.formValidationService = new _FormValidationService2.default();

    this.retailPriceList = {};

    this.selectOptions = {};
    this.selectDefaults = {};

    this.initializeEnums();
    this.configureForm();

    this.loadRetailPriceList();
  }

  (0, _createClass3.default)(RetailPriceListEditController, [{
    key: 'initializeEnums',
    value: function initializeEnums() {
      var ctrl = this;
      var enumList = [{ enumName: 'VEHICLE_BODY_TYPE', propName: 'bodyTypeE' }, { enumName: 'TRANSMISSION_TYPE', propName: 'transmissionTypeE' }, { enumName: 'FUEL_TYPE', propName: 'fuelTypeE' }, { enumName: 'VEHICLE_TYPE', propName: 'vehicleTypeE' }];

      enumList.map(function (item) {
        var enumsArray = ctrl.convertEnumToKeyValueList(ctrl.enums[item.enumName]);
        ctrl.selectOptions[item.propName] = enumsArray;
        ctrl.selectDefaults[item.propName] = ctrl.getDefaultOption(enumsArray, item.propName);
        ctrl.updateModelFromSelect(item.propName);
      });
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj) {
      var objList = [];

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'getDefaultOption',
    value: function getDefaultOption(enumsArray, propName) {
      var propVal = void 0;

      try {
        propVal = eval('this.retailPriceList.' + propName);
      } catch (e) {}

      if (propVal) {
        return (0, _lodash.find)(enumsArray, function (o) {
          return o.id === propVal;
        });
      } else {
        return enumsArray[0];
      }
    }
  }, {
    key: 'updateModelFromSelect',
    value: function updateModelFromSelect(modelProperty) {
      var selectDefaultProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : modelProperty;
      var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

      this.retailPriceList[modelProperty] = this.selectDefaults[selectDefaultProperty][idProperty];
    }
  }, {
    key: 'configureForm',
    value: function configureForm() {
      var ctrl = this;

      ctrl.formValidationService.initialize(ctrl.retailPriceList);

      ctrl.formValidationService.addField({
        fieldName: 'variant',
        displayName: 'Variant',
        type: 'text',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'retailPrice',
        displayName: 'Retail Price',
        type: 'float',
        required: true
      });

      ctrl.formValidationService.addField({
        fieldName: 'capacity',
        displayName: 'Capacity',
        type: 'float',
        allowedDecimals: 1,
        range: {
          min: 0.9,
          max: 6.2
        }
      });
    }
  }, {
    key: 'loadRetailPriceList',
    value: function loadRetailPriceList() {
      var _this = this;

      var ctrl = this;

      if (ctrl.$stateParams.retailPriceListId) {
        ctrl.loadingService.showLoading('editRetailPriceList', 'Loading Retail Price List ...');

        ctrl.retailPriceListService.getRetailPriceList(ctrl.$stateParams.retailPriceListId).then(function (response) {
          (0, _assign2.default)(ctrl.retailPriceList, response.data);
          _this.initializeEnums();
          _this.configureForm();
        }).catch(function (err) {}).finally(function () {
          ctrl.loadingService.hideLoading('editRetailPriceList');
        });
      }
    }
  }, {
    key: 'redirectToParent',
    value: function redirectToParent(newCompanyId) {
      this.$state.go('viewRetailPriceList');
    }
  }, {
    key: 'editRetailPriceList',
    value: function editRetailPriceList() {
      var _this2 = this;

      var ctrl = this;

      if (!ctrl.formValidationService.validateForm()) {
        return;
      }

      this.state = 'Saving';

      ctrl.loadingService.showLoading('editRetailPriceList', 'Saving Changes ...');

      //Massage data
      ctrl.retailPriceList.bodyType = ctrl.retailPriceList.bodyTypeE;
      ctrl.retailPriceList.transmissionType = ctrl.retailPriceList.transmissionTypeE;
      ctrl.retailPriceList.fuelType = ctrl.retailPriceList.fuelTypeE;
      ctrl.retailPriceList.vehicleType = ctrl.retailPriceList.vehicleTypeE;

      ctrl.retailPriceListService.editRetailPriceList(ctrl.retailPriceList).then(function (response) {
        _this2.state = 'Saved';
        ctrl.redirectToParent();
      }).catch(function (err) {
        if (err.status === 400) {
          //Bad Request
          ctrl.state = 'ModelError';

          err.data.map(function (item) {
            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        } else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      }).finally(function () {
        ctrl.loadingService.hideLoading('editRetailPriceList');
      });
    }
  }]);
  return RetailPriceListEditController;
}();

exports.default = RetailPriceListEditController;


// WEBPACK FOOTER //
// ./client/app/components/admin/retailPriceList/retailPriceListEdit/retailPriceListEdit.controller.js